module.exports = __webpack_public_path__ + "static/media/li.7f2cb3e7.svg";